<template>
    <div class="qingwu">
        <el-form  label-width="100px" ref="info" :model="info">
          <el-form-item label-width="160px" label="邀请有礼标题" prop="title" :rules="[{required:true,message:'有效期不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.title" style="width:360px;"></el-input></el-form-item>
            <el-form-item label-width="160px" label="邀请有礼图片" prop="logo">
                <el-upload class="avatar-uploader"  :action="$api.logoUpload" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" >
                    <img v-if="info.logo" :src="info.logo" class="avatar-upload">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
          <el-form-item label-width="160px" label="奖励金额" prop="jianglje" :rules="[{required:true,message:'不能为空',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.jianglje" placeholder="0"><template slot="append">元</template></el-input></el-form-item>
          <el-form-item label-width="160px" label="邀请有效范围" prop="yaoqfw" :rules="[{required:true,message:'不能为空',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.yaoqfw" placeholder="0"><template slot="append">公里</template></el-input></el-form-item>
          <el-form-item label-width="160px" label="温馨提示" prop="yaoqsm" :rules="[{required:true,message:'温馨提示不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入内容" v-model="info.yaoqsm" :rows="7" style="width:360px;"></el-input></el-form-item>
            <el-form-item label-width="160px" label="备注："><el-tag type="info">762*358px</el-tag></el-form-item>
            <el-form-item label-width="160px">
                <el-button type="primary" @click="submitForm('info')">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          info:{
            title:'',
              logo:'',
            jianglje:'',
            yaoqsm:''
          },
          upload_headers:{},
          logo:''
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleAvatarSuccess(res) {
            this.info.logo = res.data;
            this.$forceUpdate();
        },
        submitForm:function(e){
            this.$refs[e].validate(res=>{
                if(res){
                    // Http 请求
                    this.$post(this.$api.dailzfConfig,this.info).then(postRes=>{
                        if(postRes.code == 200){
                            this.$message.success("编辑成功");
                            this.get_alipayapp_config();
                        }else{
                            this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_alipayapp_config(){
            this.$get(this.$api.dailzfConfig).then(res=>{
                if(res.data != null){
                    this.info  = res.data;
                }
            });
        },
    },
    created() {
        this.get_alipayapp_config();
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>
